import { LayoutConfigModel } from '../../_base/layout';

export class LayoutConfig {
	public defaults: LayoutConfigModel = {
		'demo': 'custom',
		// == Base Layout
		'self': {
			'layout': 'fluid', // fluid|boxed
			'body': {
				'background-image': './assets/media/misc/bg-1.jpg',
				'class':'nfc-custom-css',
				'font_size':'small'
			},
			'logo': {
				'dark': './assets/media/logos/logo-light.png',
				'light': './assets/media/company-logos/NFC-logo-130x120.png',
				'brand': './assets/media/logos/logo-light.png',
				'green': './assets/media/logos/logo-light.png'
			}
		},
		// == Page Splash Screen loading
		'loader': {
			'enabled': true,
			'type': 'spinner-logo',
			'logo': './assets/media/company-logos/NFC-logo-130x120.png',
			'message': 'Please wait...'
		},
		// == Colors for javascript
		'colors': {
			'state': {
				'brand': '#5d78ff',
				'dark': '#282a3c',
				'light': '#ffffff',
				'primary': '#5867dd',
				'success': '#34bfa3',
				'info': '#36a3f7',
				'warning': '#ffb822',
				'danger': '#fd3995'
			},
			'base': {
				'label': [
					'#c5cbe3',
					'#a1a8c3',
					'#3d4465',
					'#3e4466'
				],
				'shape': [
					'#f0f3ff',
					'#d9dffa',
					'#afb4d4',
					'#646c9a'
				]
			}
		},
		'header': {
			'self': {
				'skin': 'dark',
				'fixed': {
					'desktop': true,
					'mobile': true
				},
				'width': 'fluid',
				'font_size':'small'
				
			},
			'topbar': {
				'search': {
					'display': true,
					'layout': 'dropdown',
					'dropdown': {
						'style': 'light'
					}
				},
				'notifications': {
					'display': true,
					'layout': 'dropdown',
					'dropdown': {
						'style': 'dark'
					}
				},
				'quick-actions': {
					'display': true,
					'layout': 'dropdown',
					'dropdown': {
						'style': 'dark'
					}
				},
				'user': {
					'display': true,
					'layout': 'dropdown',
					'dropdown': {
						'style': 'dark'
					}
				},
				'languages': { display: true },
				'cart': { display: false },
				'quick-panel': { display: true },
				'icon-style': 'duotone',
				'font_size':'small'
			},
			'search': { display: true },
			'menu': {
				'self': {
					'display': false,
					'layout': 'default',
					'root-arrow': false
				},
				'desktop': {
					'arrow': true,
					'toggle': 'click',
					'submenu': {
						'skin': 'dark',
						'arrow': true
					}
				},
				'mobile': {
					'submenu': {
						'skin': 'dark',
						'accordion': true
					}
				}
			}
		},
		'subheader': {
			'display': true,
			'layout': 'subheader-v0',
			'fixed': true,
			'width': 'fluid',
			'style': 'solid',
			'font_size':'small',
			'clear':false
		},
		'content': {
			'width': 'fluid',
			'font_size':'small',
			'fit-top':false,
			'font_weight':'medium'
		},
		'toolbar': {
			'display': true
		},
		'brand': {
			'self': {
				'skin': 'dark'
			}
		},
		'aside': {
			'self': {
				'skin': 'dark',
				'display': true,
				'fixed': true,
				'minimize': {
					'toggle': true,
					'default': false
				},
				'font_size':'small'
			},
			'footer': {
				'self': {
					'display': true
				}
			},
			'menu': {
				'dropdown': false,
				'scroll': false,
				'submenu': {
					'accordion': true,
					'dropdown': {
						'arrow': true,
						'hover-timeout': 500
					}
				},
				'icon-style': 'duotone'
			}
		},
		'data_table': {
			'height': 'normal'
		},
		'footer': {
			'self': {
				'width': 'fluid',
				'font_size':'small'
			}
		},
		'basic_layout':{
			'theme':'darkLeft',
			'font_size':'medium',
			'data_table':'normal',
		}
	};

	/**
	 * Good place for getting the remote config
	 */
	public get configs(): LayoutConfigModel {
		return this.defaults;
	}
}
